<template>
    <div class="contact-box">
        <base-header :head_id="head_id" :name="name" :account_list="account_list"></base-header>
        <base-title :title="`联系客服`"></base-title>
        <div class="msg-box">
            <p>在线客服QQ：2852355771</p>
            <p>
                <span>或在09电竞平台PC客户端上点击“在线客服”</span>
            </p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'contact',
    data() {
        return {
            head_id: this.$storage.getHeadId(),
            name: this.$storage.getUserName(),
            account_list: JSON.parse(this.$storage.getAccountList()),
        }
    },
    created() {

    },
    methods: {
        
    },
}
</script>
<style lang="scss" scoped>
.contact-box {
    width: 100%;
    height: 100vh;
    position: relative;
  .msg-box{
      width: 100%;
      height: 1rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
        p {
        width: 100%;
        color: #212121;
        font-size: 0.36rem;
        height: 0.36rem;
        line-height: 0.36rem;
        text-align: center;
        font-weight: bold;
        span {
            color: #ff0000;
            font-size: 0.22rem;
            font-weight: normal;
            display: block;
            margin-top: 0.1rem;
        }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/view/contact.vue